import { useTranslation } from 'react-i18next';
import { Flex, Text } from '@huspy/briks-web';
import { Divider, VStack } from '@huspy/styled-system/jsx';
import { useEffect } from 'react';
import { trackAmplitudeEvent } from '@shared/analytics/amplitude';
import { USER_EVENTS } from '@shared/analytics/events';
import { Opportunity } from '@modules/opportunities/entities/opportunity/opportunity.entity';
import { BankCard } from '@modules/opportunities/presentation/pages/CaseCreation/views/BankSubmission/SubmitApplications/components/BankCard';
import { AllBanksCard } from '@modules/opportunities/presentation/pages/CaseCreation/views/BankSubmission/SubmitApplications/components/AllBanksCard';
import { CreditUsage } from '@modules/opportunities/presentation/pages/CaseCreation/views/BankSubmission/SubmitApplications/components/CreditUsage';

const baseTranslation = 'opportunity.caseSubmission.submitApplications.bankAndHuspySubmission';

export const HuspyAndBankSubmission = ({ opportunity }: {
  opportunity: Opportunity;
}) => {
  const { t } = useTranslation();

  useEffect(() => {
    // Track view
    trackAmplitudeEvent(USER_EVENTS.CASE.CASE_BANK_SUBMISSION_SECTION_VIEWED, {
      addToContext: true,
      client_id: opportunity.client_external_id,
      case_id: opportunity.opportunity_external_id,
      banks: opportunity.bank_applications.map((bankApplication) => bankApplication.bank_details.external_id),
    });
  }, [opportunity]);

  return (
    <>
      <VStack gap='spacing-1' alignItems='flex-start' mb='4'>
        <Text size='3xl' weight='medium'>
          {t(`${baseTranslation}.title`)}
        </Text>
        <Text size='lg' weight='regular' color='text-tertiary'>
          {t(`${baseTranslation}.subtitle`)}
        </Text>
      </VStack>
      {opportunity.bank_applications.length > 1 && (
        <>
          <AllBanksCard opportunity={ opportunity } />
          <Divider my='5' />
        </>
      )}
      <Flex direction='column' gap='4'>
        {opportunity.bank_applications.map((item) => (
          <BankCard
            key={ item.bank_application_external_id }
            bankApplication={ item }
            opportunity={ opportunity }
          />
        ))}
      </Flex>
      <Divider my='5' />
      <CreditUsage />
    </>
  );
};
